import ajax from '../../assets/js/interceptor';
import util from '../../assets/js/util';
import { getDepartmentData } from '@/api/userManage.js';
import { getDepartment } from '@/api/workflow';

export default {
  namespaced: true,
  state: {
    totalCount: 0,
    dataSource: []
  },
  mutations: {
    SAVE_STATE (state, payload = {}) {
      // 由于不想全部把state给改了，所以我想把每一个数据都单独塞一下
      const keyList = Object.keys(payload);
      keyList.forEach(key => {
        state[key] = payload[key];
      });
    }
  },
  actions: {
    // 整理接口返回的数据
    getUserPermission ({ commit, dispatch, state }, payload) {
      // ajax.get('www.aldf.com');
    },
    getTableInfo ({ commit, dispatch, state }, payload) {
      // const data = '{"code":200,"msg":"操作成功","data":[{"id":"menu_9dbc1e450936489980373517f820f17d","appId":"app_65ace6b435714ee88d4d9806d49240f5","parentMenuId":"0","parentMenuName":null,"menuName":"quanxian","menuType":2,"menuCode":"234","menuStatus":1,"menuSortNum":123},{"id":"menu_1f66ef035e044bda94fc276d7c31eb94","appId":"app_65ace6b435714ee88d4d9806d49240f5","parentMenuId":"","parentMenuName":null,"menuName":"阿道夫","menuType":1,"menuCode":"123","menuStatus":1,"menuSortNum":21},{"id":"menu_44fb91eabd9c418f89ed465b188634c4","appId":"app_65ace6b435714ee88d4d9806d49240f5","parentMenuId":"0","parentMenuName":null,"menuName":"login","menuType":3,"menuCode":"34534","menuStatus":1,"menuSortNum":1112341},{"id":"menu_371b550d41074650a1cc79f213f4bb41","appId":"app_65ace6b435714ee88d4d9806d49240f5","parentMenuId":"menu_1f66ef035e044bda94fc276d7c31eb94","parentMenuName":null,"menuName":"首位","menuType":1,"menuCode":"12333333","menuStatus":1,"menuSortNum":1},{"id":"menu_8e1aad062e9c4f12a0caf4285d6bd5f1","appId":"app_65ace6b435714ee88d4d9806d49240f5","parentMenuId":"menu_1f66ef035e044bda94fc276d7c31eb94","parentMenuName":null,"menuName":"阿道夫二级","menuType":1,"menuCode":"1222","menuStatus":1,"menuSortNum":3},{"id":"menu_0b59e6f087384825b8dcfa8758b27f3c","appId":"app_65ace6b435714ee88d4d9806d49240f5","parentMenuId":"menu_9dbc1e450936489980373517f820f17d","parentMenuName":null,"menuName":"quanxian2ji","menuType":2,"menuCode":"23","menuStatus":1,"menuSortNum":123}]}';
      // const json = JSON.parse(data);
      // const list = json.data;
      ajax.post('/v1/role/list', payload.filter).then(res => {
        const { data } = res;
        if (data.code == 200) {
          // TODO: 菜单排序
          // let result = [];
          const list = data.data.records;
          commit('SAVE_STATE', {
            dataSource: list, totalCount: data.data.total
          });
        }
      });
    },
    // 自定义部门的数据
    getDepartmentInfo ({ commit, dispatch, state }, payload) {
      // selectedIds放relationid 转成id传给compareListToChecked
      const { selectedIds } = payload;
      return new Promise(resolve => {
        getDepartmentData().then(res => {
          const { code, data } = res.data;
          if (code == 200) {
            const dataMap = data.map(item => {
              const { childDepartmentId, childDepartmentName, departmentId, checked, ...rest } = item;
              return {
                ...rest,
                id: childDepartmentId,
                title: childDepartmentName,
                pid: departmentId,
                toggleOpen: false,
                active: false,
                checked: false, // 需要给个初始值
                level: 0
              };
            });
            util.compareListToChecked(dataMap, selectedIds);
            const addIntiData = [...dataMap];
            const { treeData, relationIdMap } = util.getDataAndMap(addIntiData);
            resolve({ originData: dataMap, treeData, treeMapData: relationIdMap });
          }
        });
      });
    }
  }
};
